import { useEffect, useState } from 'react';

interface ResultScreenProps {
  onOpenBot: () => void;
}

export default function ResultScreen({ onOpenBot }: ResultScreenProps) {
  const [animate, setAnimate] = useState(false);
  const [fanUsername] = useState(() => {
    // Генерируем случайный ник
    const usernames = ['lilchee4', 'anna_smile', 'max_power', 'kate_sun', 'alex_pro', 'maria_star'];
    return usernames[Math.floor(Math.random() * usernames.length)];
  });
  const [visits] = useState(() => Math.floor(Math.random() * 15) + 8); // 8-22 раз

  useEffect(() => {
    setAnimate(true);
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-[#0f0f0f]">
      {/* Telegram Header */}
      <div className="w-full bg-[#212121] px-4 py-3 flex items-center gap-3">
        <div className="w-10 h-10 bg-[#34C759] rounded-full flex items-center justify-center">
          <i className="ri-checkbox-circle-fill text-white text-xl"></i>
        </div>
        <div>
          <h1 className="text-white font-semibold text-base">Результат готов</h1>
          <p className="text-[#8E8E93] text-xs">Сканирование завершено</p>
        </div>
      </div>

      <div className={`flex-1 flex flex-col justify-between p-4 transition-all duration-1000 ${animate ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
        <div className="flex-1 flex flex-col justify-center">
          {/* Success icon */}
          <div className="text-center mb-8">
            <div className="w-24 h-24 bg-[#34C759] rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
              <i className="ri-user-heart-fill text-white text-5xl"></i>
            </div>
            <h2 className="text-2xl font-semibold text-white mb-2">
              Тайный фанат найден!
            </h2>
            <p className="text-sm text-[#8E8E93] max-w-xs mx-auto">
              Мы обнаружили человека, который проявляет особый интерес к вашему профилю
            </p>
          </div>

          {/* Result card */}
          <div className="space-y-3 mb-6">
            <div className="bg-[#1C1C1E] rounded-xl p-4">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-[#2AABEE] to-[#64D2FF] rounded-full flex items-center justify-center">
                  <i className="ri-user-heart-fill text-white text-2xl"></i>
                </div>
                <div className="flex-1">
                  <p className="text-white font-semibold text-base">Твой тайный фанат:</p>
                  <p className="text-[#2AABEE] text-lg font-medium">@{fanUsername}</p>
                </div>
                <div className="w-10 h-10 bg-[#34C759] rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
              </div>

              <div className="space-y-3 pt-3 border-t border-[#2C2C2E]">
                <div className="flex items-center justify-between">
                  <span className="text-[#8E8E93] text-sm">Уровень активности</span>
                  <div className="flex items-center gap-2">
                    <div className="flex gap-1">
                      <div className="w-1.5 h-4 bg-[#34C759] rounded-full"></div>
                      <div className="w-1.5 h-4 bg-[#34C759] rounded-full"></div>
                      <div className="w-1.5 h-4 bg-[#34C759] rounded-full"></div>
                      <div className="w-1.5 h-4 bg-[#34C759] rounded-full"></div>
                      <div className="w-1.5 h-4 bg-[#2C2C2E] rounded-full"></div>
                    </div>
                    <span className="text-white text-sm font-medium">Высокий</span>
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-[#8E8E93] text-sm">Посещаемость</span>
                  <span className="text-white text-sm font-medium">{visits} раз за неделю</span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-[#8E8E93] text-sm">Частота просмотров</span>
                  <span className="text-white text-sm font-medium">Ежедневно</span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-[#8E8E93] text-sm">Тип отношений</span>
                  <span className="text-white text-sm font-medium">Друг/Знакомый</span>
                </div>

                <div className="flex items-center justify-between">
                  <span className="text-[#8E8E93] text-sm">Время наблюдения</span>
                  <span className="text-white text-sm font-medium">2+ месяца</span>
                </div>
              </div>
            </div>

            {/* Info card */}
            <div className="bg-[#1C1C1E] rounded-xl p-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#34C759]/20 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-information-line text-[#34C759] text-lg"></i>
                </div>
                <div className="flex-1">
                  <p className="text-white text-sm font-medium mb-1">Результат готов!</p>
                  <p className="text-[#8E8E93] text-xs leading-relaxed">
                    Этот пользователь проявляет повышенный интерес к вашему профилю. Данные основаны на анализе активности и частоты взаимодействий.
                  </p>
                </div>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-2">
              <div className="bg-[#1C1C1E] rounded-xl p-3 text-center">
                <div className="w-8 h-8 bg-[#34C759]/20 rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-shield-check-line text-[#34C759] text-lg"></i>
                </div>
                <p className="text-[#8E8E93] text-xs">Безопасно</p>
              </div>
              <div className="bg-[#1C1C1E] rounded-xl p-3 text-center">
                <div className="w-8 h-8 bg-[#2AABEE]/20 rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-flashlight-line text-[#2AABEE] text-lg"></i>
                </div>
                <p className="text-[#8E8E93] text-xs">Быстро</p>
              </div>
              <div className="bg-[#1C1C1E] rounded-xl p-3 text-center">
                <div className="w-8 h-8 bg-[#FF9500]/20 rounded-full flex items-center justify-center mx-auto mb-2">
                  <i className="ri-star-fill text-[#FF9500] text-lg"></i>
                </div>
                <p className="text-[#8E8E93] text-xs">Точно</p>
              </div>
            </div>
          </div>
        </div>

        {/* Share button */}
        <div className="space-y-3">
          <button
            onClick={() => {
              // Можно добавить функционал шаринга
            }}
            className="w-full bg-[#2AABEE] text-white font-medium text-base py-4 rounded-xl hover:bg-[#1E96D3] active:bg-[#1A7FB8] transition-colors duration-200 flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
          >
            <i className="ri-share-line text-xl"></i>
            Поделиться результатом
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          
          <p className="text-[#8E8E93] text-xs text-center">
            Узнайте, кто ваш тайный фанат прямо сейчас
          </p>
        </div>
      </div>
    </div>
  );
}
